// extracted by mini-css-extract-plugin
export default {"section-container":"styles__section-container--oMJxS","section-children-container":"styles__section-children-container--pQjI7","line-separator":"styles__line-separator--LX5J7"};